import { useQuery } from '@tanstack/react-query';
import { WarrantyProviderApi } from 'api';

/**
 * Custom React Query hook to fetch warranty providers list.
 *
 * @param {{ onError?: (error: Error) => void }} callbacks
 * @returns {import("@tanstack/react-query").UseQueryResult<any, Error>}
 */
export function useGetWarrantyProviders({ onError } = {}) {
  return useQuery({
    queryKey: ['warranty-providers'],
    queryFn: () =>
      WarrantyProviderApi.get()
        .then((res) => res.data)
        .catch((error) => {
          typeof onError === 'function' && onError(error);
        }),
    staleTime: Infinity,
    placeholderData: [],
  });
}
